import {SubProduct} from './SubProduct';
import {Product} from './Product';

export class Package {

  public id: number;
  public inputType: string;
  public required: string;
  public name?: string;
  public products: Product[] = [];
  public packageProducts: any;
  public translations: any;
  public translationEntries = {};
  public translationKeys = [];
  public deleted: boolean;

  constructor() {
    this.translations = [];
  }
}
